import React from 'react';

import { createClassName } from 'utils/createClassName';

import './adminContentLayoutStyles.scss';

type Props = {
  headNode: React.ReactNode;
  bodyNode: React.ReactNode;
};

export const AdminContentLayout = (props: Props) => {
  const { headNode, bodyNode } = props;

  const createElementClassName = createClassName('admin-content-layout');

  return (
    <div className={createElementClassName('wrapper')}>
      <div className={createElementClassName('head-slot')}>{headNode}</div>
      <div className={createElementClassName('body-slot')}>
        <div className={createElementClassName('body-inner')}>{bodyNode}</div>
      </div>
    </div>
  );
};
